import { useState } from 'react';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import WhenTrainingNeeded from './components/WhenTrainingNeeded';
import WhyTrainingsFail from './components/WhyTrainingsFail';
import WhatTrainingIncludes from './components/WhatTrainingIncludes';
import SkillsDeveloped from './components/SkillsDeveloped';
import TrainingFormats from './components/TrainingFormats';
import SuitableCompanies from './components/SuitableCompanies';
import ResultsAfterTraining from './components/ResultsAfterTraining';
import SalesPulseAuditResults from '@/components/feature/SalesPulseAuditResults';
import ProjectTimeline from './components/ProjectTimeline';
import WhyWorkWithMe from './components/WhyWorkWithMe';
import ExpertArticle from './components/ExpertArticle';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ReadNextSection from './components/ReadNextSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import Footer from '@/components/feature/Footer';

function PageMeta() {
  return (
    <>
      <SeoTitle title="Обучение отдела продаж | Business Training" />
      <meta name="description" content="Обучение отдела продаж в Минске и онлайн: диагностика, программа развития, практические тренинги и рост конверсии команды." />
      <meta name="keywords" content="корпоративные тренинги, обучение сотрудников, тренинги по продажам, тренинг по переговорам, тренинг по лидерству, тимбилдинг Минск, бизнес-игры Беларусь, тренинг для отдела продаж, soft skills, Минск, Беларусь" />
      <link rel="canonical" href="https://business-training.by/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh" />
      <meta property="og:title" content="Обучение отдела продаж | Business Training" />
      <meta property="og:description" content="Обучение отдела продаж в Минске и онлайн: диагностика, программа развития, практические тренинги и рост конверсии команды." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://business-training.by/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh" />
      <meta property="og:locale" content="ru_RU" />
      <meta property="og:image" content="https://readdy.ai/api/search-image?query=Professional%20corporate%20training%20scene%20with%20diverse%20business%20professionals%20engaged%20in%20strategic%20workshop%2C%20bright%20modern%20office%20interior%2C%20warm%20ambient%20lighting%2C%20collaborative%20atmosphere%2C%20clean%20minimalist%20aesthetic%2C%20soft%20cream%20and%20beige%20tones%2C%20elegant%20B2B%20setting%2C%20high-end%20corporate%20photography%20style%2C%20no%20text%20no%20logos%20no%20branding&width=1200&height=630&seq=sales-og-2026&orientation=landscape" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Обучение отдела продаж | Business Training" />
      <meta name="twitter:description" content="Обучение отдела продаж в Минске и онлайн: диагностика, программа развития, практические тренинги и рост конверсии команды." />
      <meta name="twitter:image" content="https://readdy.ai/api/search-image?query=Professional%20corporate%20training%20scene%20with%20diverse%20business%20professionals%20engaged%20in%20strategic%20workshop%2C%20bright%20modern%20office%20interior%2C%20warm%20ambient%20lighting%2C%20collaborative%20atmosphere%2C%20clean%20minimalist%20aesthetic%2C%20soft%20cream%20and%20beige%20tones%2C%20elegant%20B2B%20setting%2C%20high-end%20corporate%20photography%20style%2C%20no%20text%20no%20logos%20no%20branding&width=1200&height=630&seq=sales-og-2026&orientation=landscape" />
      <meta name="last-modified" content="2026-07-15" />
      <meta name="geo.region" content="BY" />
      <meta name="geo.placename" content="Минск" />
      <meta name="geo.position" content="53.9006;27.5590" />
    </>
  );
}

const salesNavLinks = [
  { label: 'Когда нужно', target: 'when-needed' },
  { label: 'Навыки', target: 'skills' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function SalesTrainingPage() {


  return (
    <>
      
      <SeoTitle title="Обучение отдела продаж | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={salesNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhenTrainingNeeded />
        <WhyTrainingsFail />
        <WhatTrainingIncludes />
        <SkillsDeveloped />
        <TrainingFormats />
        <SuitableCompanies />
        <ResultsAfterTraining />
        <SalesPulseAuditResults background="gray" />
        <ProjectTimeline />
        <WhyWorkWithMe />
        <ExpertArticle />
        <FAQSection />
        <LeadMagnetBlock variant="full" />
        <CTASection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}